export default __webpack_public_path__ + "static/media/silla-sin-puntos-cut.86e810f3.png";